var map = {
	"./033-bm.webp": 1257,
	"./033-cn.webp": 1258,
	"./033.webp": 1259,
	"./13-bm.webp": 1260,
	"./13-cn.webp": 1261,
	"./13.webp": 1262,
	"./3-bm.webp": 1263,
	"./3-cn.webp": 1264,
	"./3.webp": 1265,
	"./angpao-bm.webp": 1266,
	"./angpao-cn.webp": 1267,
	"./angpao.webp": 1268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1256;